module.exports = __webpack_public_path__ + "img/5DayYogaChallenge.6cebb453.jpeg";